module.exports = __webpack_public_path__ + "static/mutual-aid-world-9d48079990ec75925f13d18f1882371e.png";